/**
 * Checks if the provided value is a React RefObject.
 */
export const isRefObject = <T>(ref: unknown): ref is React.RefObject<T> => {
  return ref !== null && typeof ref === 'object' && 'current' in ref;
};
